export const GOOGLE_CONFIG = {
  clientId:
    "79887996241-lkot8h9s6ehcv4cd07kl9nsugt965pr8.apps.googleusercontent.com",
  discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"],
  scope: "profile",
};
export const GOOGLE_API_KEY = "AIzaSyAVLUGVn8ip6SMEpyOGUSZGstOJqArLUxk";
export const GOOGLE_SCOPES = "https://www.googleapis.com/auth/drive.appdata";
